import { zips } from '../data/zipCodes.json';

export const checkMediaNetwork = (zip, floors, buildingType) => {
	const validZips = zips;

	if (
		Number(floors) >= 5 &&
		(buildingType === 'business' || buildingType === 'residential') &&
		validZips.includes(Number(zip))
	) {
		return true;
	}
	return false;
};

export const checkAdScreenAndSmartMirror = (class_cabine, glass_interieur, throughloader, depth_of_cabin, width_of_cabin) => {
	if (!class_cabine && !glass_interieur && !throughloader && Number(depth_of_cabin) > Number(width_of_cabin)) return true;
	return false;
};

export const checkOrientationValue = (type, height_of_cabin, width_of_cabin, width_of_cabin_door, height_of_cabin_door) => {
	const refValue = type === 'portrait' ? height_of_cabin : width_of_cabin;
	const value = Math.sqrt(Math.pow(width_of_cabin_door, 2) + Math.pow(height_of_cabin_door, 2));

	console.log('orientationValue:', value);
	if (value > refValue) return true;
	return null;
};

export const checkFullHeight = (width_of_cabin, height_of_cabin, width_of_cabin_door, height_of_cabin_door) => {
	if (
		checkOrientationValue('portrait', height_of_cabin, width_of_cabin, width_of_cabin_door, height_of_cabin_door) &&
		(
			((880 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1700) && (2000 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300)) ||
			((1010 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1800) && (2000 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300)) ||
			((1140 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1800) && (2100 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300))
		)
	) {
		return true;
	} 
	return false;
};

export const checkHalfHeight = (width_of_cabin, height_of_cabin, width_of_cabin_door, height_of_cabin_door) => {
	if (
		checkOrientationValue('landscape', height_of_cabin, width_of_cabin, width_of_cabin_door, height_of_cabin_door) &&
		(
			(1400 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1800 && 2000 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300) ||
			(1620 <= Number(width_of_cabin) && Number(width_of_cabin) <= 2000 && 2000 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300)
		)
	) {
		return true;
	} 
	return false;
};

export const checkSizePortrait = (inch, width_of_cabin, height_of_cabin) => {
	if (inch === '55')
		return (880 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1700) && (2000 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300);
	if (inch === '65') 
		return (1010 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1800) && (2000 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300);
	if (inch === '75')
		return (1140 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1800) && (2100 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300);
};

export const checkSizeLandscape = (inch, width_of_cabin, height_of_cabin) => {
	if (inch === '55')
		return 1400 <= Number(width_of_cabin) && Number(width_of_cabin) <= 1800 && 2000 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300;
	if (inch === '65')
		return 1620 <= Number(width_of_cabin) && Number(width_of_cabin) <= 2000 && 2080 <= Number(height_of_cabin) && Number(height_of_cabin) <= 2300;
};
